var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 46.756 90 c -15.565 0 -30.721 -8.071 -39.047 -22.492 c -6.01 -10.41 -7.607 -22.537 -4.496 -34.148 C 6.324 21.749 13.77 12.045 24.18 6.035 c 8.604 -4.968 18.353 -6.926 28.201 -5.661 c 0.838 0.108 1.518 0.73 1.698 1.555 c 0.182 0.825 -0.176 1.675 -0.892 2.124 c -14.77 9.253 -19.511 28.329 -10.794 43.429 c 8.719 15.1 27.609 20.532 43.008 12.367 c 0.743 -0.398 1.659 -0.28 2.284 0.289 c 0.624 0.569 0.823 1.47 0.498 2.249 c -3.829 9.159 -10.4 16.626 -19.004 21.593 C 62.113 88.06 54.385 90 46.756 90 z M 46.538 4.001 C 39.41 4.007 32.46 5.873 26.18 9.499 C 6.601 20.803 -0.131 45.929 11.173 65.508 s 36.428 26.311 56.008 15.007 c 6.28 -3.625 11.371 -8.712 14.941 -14.882 c -16.184 5.635 -34.346 -0.83 -43.192 -16.151 C 30.085 34.161 33.565 15.199 46.538 4.001 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIcon);
export default __webpack_public_path__ + "static/media/moon-icon.02dc26e9abac79e75bfeca5fac80212f.svg";
export { ForwardRef as ReactComponent };